<div class="modal-header" *ngIf="IsModal">
  <h5 class="modal-title">{{Item?.id ? 'Modifica Corriere' : 'Nuovo Corriere'}}</h5>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [class.modal-body]="IsModal" [class.card]="!IsModal">
  <div [class.card-body]="!IsModal">
    <div class="row">
      <div class="form-group col-md-3">
        <label for="nome" class="control-label col-form-label" >Corriere:</label>
        <input [(ngModel)]="Item.nominativo" placeholder="nominativo" type="text" id="nome" class="form-control">
      </div>
      <div class="form-group col-md-3">
        <label for="link" class="control-label col-form-label" >Link:</label>
        <input [(ngModel)]="Item.link" placeholder="nominativo" type="text" id="link" class="form-control">
      </div>
      <div class="form-group col-md-3">
        <label for="nome" class="control-label col-form-label" >Tipo:</label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" *ngIf="Tipi"  [placeholder]="'Seleziona'" name="categorie" [data]="Tipi" [(ngModel)]="Item.tipiObject"></ng-multiselect-dropdown>
      </div>
      <div class="form-group col-md-3">
        <label for="key" class="control-label col-form-label" >Chiave:</label>
        <input [(ngModel)]="Item.key" placeholder="Chiave" type="text" id="key" class="form-control">
      </div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label  class="" >Test:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.test">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="form-group col-md-3">
        <label for="username" class="control-label col-form-label" >Username:</label>
        <input [(ngModel)]="Item.username" placeholder="Username" type="text" id="username" class="form-control">
      </div>
      <div class="form-group col-md-3">
        <label for="password" class="control-label col-form-label" >Password:</label>
        <input [(ngModel)]="Item.password" placeholder="Password" type="text" id="password" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Ritiro:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.ritiro">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Triangolazione:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.triangolazione">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Internazionale:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.internazionale">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Nazionale:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.nazionale">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Assicurazione:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.assicurazione">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Contrassegno:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.contrassegno">
          <span class="slider round-slider"></span>
        </label>
      </div>
      <div class="col-md-9"></div>
      <div class=" col-md-3 d-flex align-items-center justify-content-between">
        <label>Tracking Laera:</label>
        <label class="switch">
          <input type="checkbox" [(ngModel)]="Item.trackingLaera">
          <span class="slider round-slider"></span>
        </label>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="Save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
